import styled from 'styled-components';
import useTranslation from 'shared/hooks/useTranslation';

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  justify-content: center;
  min-height: 32vh;
`;

const BadgeHeader = styled.h1`
  color: ${({ theme }) => theme.COLORS.SECONDARY};
  font-weight: 700;
  font-size: 2.8rem;
  line-height: 1.2;
  text-align: center;
  width: 100%;
`;

const Description = styled.div`
  font-size: 1.8rem;
  text-align: center;
`;

export default function Header(): JSX.Element {
  const { t } = useTranslation('badgesPage');

  return (
    <HeaderSection>
      <BadgeHeader>{t('earnBadges')}</BadgeHeader>
      <Description>{t('specialAwards')}</Description>
    </HeaderSection>
  );
}
